import { useAuth } from "@contexts/AuthContext";
import { Box } from "@mui/material";

export default function HighRiskWoPage() {
    const {user} = useAuth();
    return <Box sx={{height: 'calc(100vh - 80px)'}}>
        <iframe src={user?.metabaseLink} width={'100%'} height={'100%'}></iframe>
    </Box>
}